module.exports = __webpack_public_path__ + "img/glassquality_2.94a24385.png";